export const countriesStatusTypes = {
    1:"ACTIVE",
    2:"SANCTIONATED"
}